import {Pagination} from '@store/common/pagination.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';
import {TaxRule} from '@store/common/organisation.enums';

export interface ClientsFilters {
  search: string;
  tableFilters: TableFilter[];
}

export namespace ClientsFilters {
  export const initTableFilters = () => TableFilterType.initTableFilters([
    TableFilterType.ORGANISATION_TYPOLOGY,
    TableFilterType.ORGANISATION_DOMAIN,
  ]);
}

export interface ClientsPagination extends Pagination {
  data: Client[];
}

export interface ClientUI {
  id: number;
  selected: boolean;
}

export interface Client {
  id: number;
  status: GlobalStatus;
  createdAt: string;
  name: string;
  email: string;
  phone: string;
  city: string;
  country: string;
  contactCount: number;
  contactName: string;
  taxRule: TaxRule;
}

export interface ClientHead {
  id: number;
  name?: string;
}
